/**
 * МЕТКИ СПЛИТА НЕ ОСТАЮТСЯ В АДРЕСНОЙ СТРОКЕ (Дима, 2026-09-28: «не нравятся ?split=a, ?split=b,
 * ?funnel=3 — читается сплит-тест»).
 *
 * `?r=<пул>` (кампания B) и `?v=<буква>` (проверка руками) нужны только серверу на ПЕРВОМ запросе:
 * он назначает воронку и кладёт cookie в ответ с HTML (server/src/ab/funnel.ts). К тому моменту, как
 * выполняется этот код, решение уже принято, и метки в адресе больше ничего не делают — только
 * показывают человеку, что его куда-то распределили, и уезжают дальше: в «поделиться ссылкой», в
 * закладку, в скриншот. main.tsx зовёт `maskSplitMarks()` до рендера: адрес заменяется тем же, но без
 * `r` и `v`, через history.replaceState — без перезагрузки и без записи в историю.
 *
 * ОСТАЛЬНОЕ — БАЙТ В БАЙТ. Строка режется по `&`, и выкидываются только сегменты с ключом `r` или `v`;
 * прочие не декодируются и не собираются заново. URLSearchParams.toString() переписал бы `%20` в `+` и
 * перекодировал бы `{}` в utm_campaign, а по адресу страницы пиксель Меты читает fbclid, GA —
 * page_location. Метки объявления (utm_*, fbclid) acquisition.ts снимает раньше, при загрузке модуля, —
 * им эта замена не мешает в любом случае.
 */

const MARKS: ReadonlySet<string> = new Set(['r', 'v'])

const keyOf = (segment: string): string => {
  const raw = segment.split('=', 1)[0] ?? ''
  try {
    return decodeURIComponent(raw.replace(/\+/g, ' ')).trim().toLowerCase()
  } catch {
    return raw.trim().toLowerCase()
  }
}

/** `?a=1&r=b&utm_source=x` → `?a=1&utm_source=x`; без меток — строка как есть; пусто — ''. */
export const withoutSplitMarks = (search: string): string => {
  const body = search.startsWith('?') ? search.slice(1) : search
  if (!body) return ''
  const segments = body.split('&')
  /* Нет меток — адрес не трогаем вовсе, даже его пустые сегменты. */
  if (!segments.some((segment) => MARKS.has(keyOf(segment)))) return search
  const kept = segments.filter((segment) => segment !== '' && !MARKS.has(keyOf(segment)))
  return kept.length ? `?${kept.join('&')}` : ''
}

/** До рендера (main.tsx): убрать `r` и `v` из адресной строки, ничего больше не трогая. */
export const maskSplitMarks = (): void => {
  if (typeof window === 'undefined') return
  const { pathname, search, hash } = window.location
  const next = withoutSplitMarks(search)
  if (next === search) return
  try {
    window.history.replaceState(window.history.state, '', `${pathname}${next}${hash}`)
  } catch {
    /* Песочница без History API — метка останется в адресе, воронка от этого не меняется. */
  }
}
